module.exports = __webpack_public_path__ + "static/img/fundoll.aa9d700a.png";